module.exports = __webpack_public_path__ + "static/media/logo-excelencia.719ea3e2.png";